import axios from "axios";
import { camelizeKeys, decamelizeKeys as underscoreKeys } from "humps";
import { routes, publicRoutes, publicRoutePrefixes } from "../config";
axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.headers.put["Content-Type"] = "application/json";
axios.defaults.headers.get["Accept"] = "application/json";
axios.defaults.xsrfHeaderName = "X-CSRF-TOKEN";
axios.defaults.transformResponse = (data) => camelizeKeys(JSON.parse(data));
axios.defaults.transformRequest = (data) => JSON.stringify(underscoreKeys(data));
axios.interceptors.response.use(undefined, (error) => {
    var _a;
    const { pathname } = window.location;
    const isPublicRoute = publicRoutes.includes(pathname) ||
        publicRoutePrefixes.some((prefix) => pathname.startsWith(prefix + "/"));
    if (((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.status) === 401 && !isPublicRoute) {
        window.location.href = routes.login();
        return new Promise(() => { });
    }
    return Promise.reject(error);
});
